module.exports = __webpack_public_path__ + "media/images/top/pap/common/hero_sp-ce19aa5aef2d1ce410a0f45b59e6df76.png";